// Hooks
import React, { useEffect, useState } from "react";

// Components
import Loading from "../../../../Shared/loading/loading";
import ProgressCard from "./progressCard";

// styles
import styles from "./trackTask.module.scss";

// Constants
import { ACCENTCOLOR } from "../../../../Shared/colors";

// Functions
import { batchPaths } from "../../../../api/batch";
import { callApi } from "../../../../api/fetch";
import Toast from "../../../../Shared/toast/toast";
import NotFoundImg from "../../../../assets/images/no-record-found.svg";
import {
  extractCustomerBatchDownload,
  triggerBrowserDownload,
} from "../batchDownload";
import { isCustomerBatchFinished } from "../normalizeBatchTask";

interface Props {
  taskList?: Array<any>;
  getTaskData: () => void;
}

const TrackTask = (props: Props) => {
  const [taskList, setTaskList] = useState<Array<any>>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setTaskList(props?.taskList?.length ? props.taskList : []);
    setLoading(false);
  }, [props.taskList]);

  const executeAction = async (batchId: string, type: string) => {
    if (!batchId) return;

    if (type === "GENERATE_DOWNLOAD_LINK") {
      const data = await callApi(
        batchPaths.generateDownloadLink(batchId),
        { method: "POST" }
      );
      const { fileUrl, fileName } = extractCustomerBatchDownload(data);
      if (!fileUrl) {
        throw new Error("Download link was not returned");
      }
      triggerBrowserDownload(fileUrl, fileName);
      return;
    }

    let endpoint = "";
    switch (type) {
      case "STOP_TASK":
        endpoint = "stopBatch/" + batchId;
        break;
      default:
        break;
    }
    if (endpoint) {
      try {
        await callApi(batchPaths.taskActions, {
          method: "POST",
          data: {
            action: endpoint,
          },
        });

        props.getTaskData && props?.getTaskData();
      } catch (error) {
        Toast(
          "error",
          (error as Error)?.message || "Something went wrong",
          "Error"
        );
        props.getTaskData && props?.getTaskData();
      }
    }
  };

  return (
    <div style={{ overflowX: "auto" }}>
      {loading ? (
        <div
          style={{ height: "100vh" }}
          className="d-flex align-items-center justify-content-center"
        >
          <Loading loadingColor={ACCENTCOLOR} />
        </div>
      ) : (
        <div style={{ height: "100%", minHeight: "100vh" }}>
          <div className={styles.batchdetailsHeading}>Batch Details</div>
          {taskList.length ? (
            <table className={styles.progressCardTable}>
              {taskList.map((item, index) => {
                  const btndisable = !isCustomerBatchFinished(item);
                  return (
                    <ProgressCard
                      key={item.batchId ?? index}
                      item={item}
                      btndisable={btndisable}
                      loading={loading}
                      executeAction={executeAction}
                    />
                  );
                })}
            </table>
          ) : (
            <div className="d-flex flex-column align-items-center justify-content-center">
              <img src={NotFoundImg} alt="no-record-found" width={"150px"} />
              <h5
                className={"mb-0"}
                style={{
                  fontStyle: "normal",
                  fontWeight: 600,
                  fontSize: "18px",
                  lineHeight: "23px",
                  textAlign: "center",
                  color: "#000",
                }}
              >
                No tasks found!
              </h5>
              <span
                style={{
                  fontFamily: "'Outfit', sans-serif",
                  fontStyle: "normal",
                  fontWeight: 400,
                  fontSize: "14px",
                  lineHeight: "18px",
                  textAlign: "center",
                  marginTop: 7,
                  maxWidth: 250,
                  color: "#666666",
                }}
              >
                Looks like you have no tasks yet in this category.
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default TrackTask;
